/**
 * Heismøte-dialogen med rival-redaktøren (fase 5B/5D). Satiren treffer
 * portvokterkulturen i de gamle forlagshusene — aldri virkelige
 * personer. Mekanikken (40 %-rull, avsløring, hevn) bor i
 * systems/rival.ts; all tekst bor her.
 */

export type HeisTone = 'hoflig' | 'spiss' | 'fiskende';

export interface HeisDialogValg {
  tone: HeisTone;
  /** Spillerens replikk på knappen. */
  label: string;
  /** Rivalens svar-replikker (1–2). */
  svar: string[];
}

/** Rivalens åpningsreplikker når dørene lukkes. */
export const HEIS_MOTE_INTRO: string[] = [
  '«Nei men. Forlagshusets nye håp. Skal vi samme vei, mon tro?»',
  '«Vi følger med på dere, må du vite. Kvalitetslitteratur krever… tålmodighet. Den har visst ikke alle.»',
];

export const HEIS_MOTE_VALG: HeisDialogValg[] = [
  {
    tone: 'hoflig',
    label: '«Alltid hyggelig. Hvordan går høsten?»',
    svar: [
      '«Strålende, naturligvis. Vi i de etablerte forlagene planlegger i tiår, ikke i kvartaler.»',
      '«Hils redaksjonen din. Det er friskt at noen fortsatt prøver.»',
    ],
  },
  {
    tone: 'spiss',
    label: '«Dere ga vel nettopp refusjonsbrev til en kommende Brage-vinner?»',
    svar: [
      '«Vi refuserer mer kvalitet enn de fleste utgir. Det er det som heter standard.»',
      '«Morsomt. Vi sees på prisutdelingen. En av oss som gjest.»',
    ],
  },
  {
    tone: 'fiskende',
    label: '«Hva jobber dere egentlig med for tiden?»',
    svar: [
      '«Nysgjerrig? Det kler deg. La meg si det slik: høsten blir… travel.»',
    ],
  },
];

/** Hint spilleren kan få ved vellykket fisking (50 %). */
export const FISKENDE_HINTS: string[] = [
  'Du fanger opp: Kapelle Damm sirkler rundt et manus du har sendt tilbake.',
  'Du fanger opp: de planlegger en stor krim-lansering — pass lanseringsvinduet ditt.',
  'Du fanger opp: en av deres egne forfattere er misfornøyd. Veldig misfornøyd.',
];

/** Når fiskingen slår feil: rivalen gjennomskuer deg. */
export const FISKENDE_AVSLORT: string =
  '«Du fisker. Sjarmerende. Nå vet jeg i det minste at dere følger med — det skal vi huske.»';

/** 5D: konfrontasjonen etter at spilleren signerte fra KD-stallen. */
export const KONFRONTASJON: string[] = [
  '«Så det er sånn vi gjør det nå? Plukke fra stallen til folk?»',
  '«Vedkommende var riktignok… vanskelig. Men prinsippet, du. Prinsippet.»',
  '«Vel. Da vet vi hvor vi har hverandre. God dag.»',
];

export const KONFRONTASJON_LUKK_LABEL = '«Det er bransjen, Preben.»';
